import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-13848">
      <span className="sr-only" data-id="element-13849">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-13850">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-13851" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-13852" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-13853">
        <div className="flex gap-8" data-id="element-13854">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-13855">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13856" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-13857">
        <div className="space-y-6" data-id="element-13858">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13859">
            <div data-id="element-13860">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-13861" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-13862" />
            </div>
            <div data-id="element-13863">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-13864" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-13865" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-13866">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-13867" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-13868" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13869">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-13870">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-13871" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-13872" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-13873">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-13874" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-13875" />
      </div>
    </div>;
}